import { Badge as BadgeRadix } from '@radix-ui/themes'
import { IconPointFilled } from '@tabler/icons-react'
import clsx from 'clsx'

type BadgeProps = {
  color?: 'default' | 'success' | 'warning' | 'error'
  title: string
  style?: string
  dotColor?: string
}
export default function Badge({ title, style, dotColor }: BadgeProps) {
  // const colorClasses = {
  //   default: "!bg-[#FAFAFA] !text-[#414651] !border !border-[#E9EAEB]",
  //   success: "!bg-[#ECFDF3] !text-[#067647] !border !border-[#ABEFC6]",
  //   warning: "bg-yellow-200 text-yellow-800",
  //   error: "bg-red-200 text-red-800",
  // };

  // const colorIconClasses = {
  //   default: "#717680",
  //   success: "#17B26A",
  //   warning: "bg-yellow-200 text-yellow-800",
  //   error: "bg-red-200 text-red-800",
  // };

  return (
    <BadgeRadix className={clsx('!h-[28px] !rounded-[8px] capitalize', style)}>
      {dotColor && <IconPointFilled color={dotColor} />}
      {title}
    </BadgeRadix>
  )
}
